import { render, staticRenderFns } from "./CSVImport.vue?vue&type=template&id=37882f3d&scoped=true&"
import script from "./CSVImport.vue?vue&type=script&lang=js&"
export * from "./CSVImport.vue?vue&type=script&lang=js&"
import style0 from "./CSVImport.vue?vue&type=style&index=0&id=37882f3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37882f3d",
  null
  
)

export default component.exports